import React, { useState } from "react";

import "./menuEditor.css";
import "../_menuComponent/menuComponent.css";

import SelectDishForm from "./selectDishForm/selectDishForm";

// General editor: create new menu, update existing menu
const MenuEditorGeneral = ({
  menu,
  dishes,
  isDishesLoading,
  handleSaveMenu,
  handleCancel,
  isFromCopy,
  originalMenuId,
  isFromUpdate
}) => {
  let menuChecked = { ...menu };
  if (menuChecked.active && isFromCopy) {
    menuChecked.active = false;
  }

  const [menuInEdit, setMenuInEdit] = useState({ ...menuChecked });
  const [isAddDishFormOpen, setIsAddDishFormOpen] = useState(false);
  const [isDishBeingAdded, setIsDishBeingAdded] = useState(false);
  const [dishesInUpdate, setDishesInUpdate] = useState([]);

  // to sort dishes
  const sortDishesByCategory = (a, b) => {
    let A = a.dishBody.category;
    let B = b.dishBody.category;

    if (A > B) {
      if (A === "САЛАТЫ") return -1;
      if (
        A === "ГАРНИРЫ" &&
        B !== "САЛАТЫ" &&
        B !== "1-е БЛЮДА" &&
        B !== "2-е БЛЮДА"
      )
        return -1;
      return 1;
    } else if (B > A) {
      if (B === "САЛАТЫ") return 1;
      if (
        B === "ГАРНИРЫ" &&
        A !== "САЛАТЫ" &&
        A !== "1-е БЛЮДА" &&
        A !== "2-е БЛЮДА"
      )
        return 1;
      return -1;
    } else {
      return 0;
    }
  };

  const dishCategorySwitch = (category) => {
    let working = category.toUpperCase();
    switch (working) {
      case "1-Е БЛЮДА":
        return "СУПЫ";
      case "2-Е БЛЮДА":
        return "ГОРЯЧИЕ БЛЮДА";
      case "САЛАТЫ":
        return "САЛАТЫ И ХОЛОДНЫЕ ЗАКУСКИ";
      default:
        return category;
    }
  };

  const handleNameInputChange = (e) => {
    const workingMenu = { ...menuInEdit };

    workingMenu.name = e.target.value;

    setMenuInEdit({ ...workingMenu });
  };

  const handleDateInputChange = (e) => {
    const workingMenu = { ...menuInEdit };

    workingMenu.menuDate = e.target.value;

    setMenuInEdit({ ...workingMenu });
  };

  const handleDescriptionInputChange = (e) => {
    const workingMenu = { ...menuInEdit };

    workingMenu.description = e.target.value;

    setMenuInEdit({ ...workingMenu });
  };

  const handlePurposeTypeChange = (e) => {
    const workingMenu = { ...menuInEdit };

    workingMenu.purposeType = e.target.value;

    setMenuInEdit({ ...workingMenu });
  };

  const handleWebsitePurposeChange = (e) => {
    const workingMenu = { ...menuInEdit };

    workingMenu.websitePurpose = e.target.value;

    setMenuInEdit({ ...workingMenu });
  };

  const handleSortByChange = (e) => {
    const workingMenu = { ...menuInEdit };

    workingMenu.sortBy = e.target.value;

    setMenuInEdit({ ...workingMenu });
  };

  const handleAddDish = (dish) => {
    const workingMenu = { ...menuInEdit };

    workingMenu.dishes = [...workingMenu.dishes, dish];

    setMenuInEdit({ ...workingMenu });

    setIsAddDishFormOpen(false);
    setIsDishBeingAdded(false);
  };

  const handleRemoveDish = (menuDishId) => {
    const workingMenu = { ...menuInEdit };

    workingMenu.dishes = workingMenu.dishes.filter(
      (dish) => dish.dishBody._id !== menuDishId
    );

    setMenuInEdit({ ...workingMenu });
  };

  const handleAddDishInUpdate = (dishId) => {
    setDishesInUpdate((dishesInUpdate) => [...dishesInUpdate, dishId]);
  };

  const handleRemoveDishFromUpdate = (dishId) => {
    setDishesInUpdate((dishesInUpdate) =>
      dishesInUpdate.filter((id) => id !== dishId)
    );
  };

  const handleUpdateDish = (dish, index, removeDishId) => {
    const workingMenu = { ...menuInEdit };

    workingMenu.dishes[index] = { ...dish };

    console.log(workingMenu.dishes[index]);

    setMenuInEdit({ ...workingMenu });

    handleRemoveDishFromUpdate(removeDishId);
    setIsDishBeingAdded(false);
  };

  return (
    <div className="menuComponent">
      <div className="menuComponent__menuBodyDiv">
        <div className="menuBodyDiv__congifDiv">
          <div className="congifDiv__menuName">
            <h3>MENU NAME</h3>
            <input
              type="text"
              name="name"
              id="name"
              onChange={handleNameInputChange}
              value={menuInEdit.name}
            />
          </div>
          <div className="congifDiv__menuDate">
            <h3>DATE</h3>
            <input
              type="date"
              name="menuDate"
              id="menuDate"
              onChange={handleDateInputChange}
              value={menuInEdit.menuDate}
            />
          </div>
          <div className="congifDiv__menuDescription">
            <h3>MENU DESCRIPTION</h3>
            <input
              type="text"
              name="description"
              id="description"
              value={menuInEdit.description}
              onChange={handleDescriptionInputChange}
            />
          </div>
          <div className="congifDiv__menuPurposeType">
            <h3>MENU TYPE</h3>
            <label
              htmlFor="website"
              className="menuPurposeType__checkboxContainer"
            >
              <input
                type="radio"
                name="purposeType"
                id="website"
                value="website"
                checked={menuInEdit.purposeType === "website" ? true : false}
                onChange={handlePurposeTypeChange}
              />
              <span className="checkmark"></span>
              Website
            </label>
            <label
              htmlFor="print"
              className="menuPurposeType__checkboxContainer"
            >
              <input
                type="radio"
                name="purposeType"
                id="print"
                value="print"
                checked={menuInEdit.purposeType === "print" ? true : false}
                onChange={handlePurposeTypeChange}
              />
              <span className="checkmark"></span>
              Printed
            </label>
          </div>
          {menuInEdit.purposeType === "website" ? (
            <div className="congifDiv__menuWebsitePurpose">
              <h3>Purpose</h3>
              <label
                htmlFor="dailyMenu"
                className="menuWebsitePurpose__checkboxContainer"
              >
                <input
                  type="radio"
                  name="websitePurpose"
                  id="dailyMenu"
                  value="dailyMenu"
                  checked={
                    menuInEdit.websitePurpose === "dailyMenu" ? true : false
                  }
                  onChange={handleWebsitePurposeChange}
                />
                <span className="checkmark"></span>
                Daily menu
              </label>
              <label
                htmlFor="orderMenu"
                className="menuWebsitePurpose__checkboxContainer"
              >
                <input
                  type="radio"
                  name="websitePurpose"
                  id="orderMenu"
                  value="orderMenu"
                  checked={
                    menuInEdit.websitePurpose === "orderMenu" ? true : false
                  }
                  onChange={handleWebsitePurposeChange}
                />
                <span className="checkmark"></span>
                Order menu
              </label>
              <label
                htmlFor="static"
                className="menuWebsitePurpose__checkboxContainer"
              >
                <input
                  type="radio"
                  name="websitePurpose"
                  id="static"
                  value="static"
                  checked={
                    menuInEdit.websitePurpose === "static" ? true : false
                  }
                  onChange={handleWebsitePurposeChange}
                />
                <span className="checkmark"></span>
                Static menu
              </label>
            </div>
          ) : null}
          {menuInEdit.websitePurpose === "orderMenu" ? (
            <div className="congifDiv__sortBy">
              <h3 className="menuComponent__subheading">SORT BY</h3>
              <label
                htmlFor="sortByCategory"
                className="sortBy__checkboxContainer"
              >
                <input
                  type="radio"
                  name="sortBy"
                  id="sortByCategory"
                  value="category"
                  checked={
                    menuInEdit.sortBy === "category" || !menuInEdit.sortBy
                      ? true
                      : false
                  }
                  onChange={handleSortByChange}
                />
                <span className="checkmark"></span>
                Category
              </label>
              <label
                htmlFor="sortBySubcategory"
                className="sortBy__checkboxContainer"
              >
                <input
                  type="radio"
                  name="sortBy"
                  id="sortBySubcategory"
                  value="subcategory"
                  checked={menuInEdit.sortBy === "subcategory" ? true : false}
                  onChange={handleSortByChange}
                />
                <span className="checkmark"></span>
                Subcategory
              </label>
            </div>
          ) : null}
        </div>
        <div
          id={`menuBodyDiv__dishesDiv${
            isFromCopy
              ? originalMenuId.trim()
              : (menu._id ? menu._id.trim() : "") + "id"
          }`}
          className="menuBodyDiv__dishesDiv"
        >
          <h3>ITEMS</h3>
          {menuInEdit.dishes &&
            menuInEdit.dishes
              .sort(sortDishesByCategory)
              .map((menuDish, index, sortedArray) => (
                <React.Fragment key={menuDish.dishBody._id}>
                  <div
                    className="dishesDiv__dishItem"
                    key={menuDish.dishBody._id}
                  >
                    <div className="dishItem__category">
                      {(sortedArray[index - 1] &&
                        sortedArray[index - 1].dishBody.category) ===
                      menuDish.dishBody.category
                        ? ""
                        : dishCategorySwitch(menuDish.dishBody.category)}
                    </div>
                    <div className="dishItem__name">
                      {menuDish.dishBody.name}
                    </div>
                    <div className="dishItem__quantity">
                      in stock: {menuDish.quantity}
                    </div>
                    <button
                      title="remove item"
                      className="dishItem__deleteBtn"
                      onClick={() => handleRemoveDish(menuDish.dishBody._id)}
                    >
                      <svg
                        className="bi bi-x-circle-fill"
                        width="1em"
                        height="1em"
                        viewBox="0 0 20 20"
                        fill="var(--btn-border-color-red)"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fillRule="evenodd"
                          d="M10 18a8 8 0 100-16 8 8 0 000 16zM7.354 6.646L10 9.293l2.646-2.647a.5.5 0 01.708.708L10.707 10l2.647 2.646a.5.5 0 01-.708.708L10 10.707l-2.646 2.647a.5.5 0 01-.708-.708L9.293 10 6.646 7.354a.5.5 0 11.708-.708z"
                          clipRule="evenodd"
                        />
                      </svg>
                    </button>
                    <button
                      title="edit/switch item"
                      className="dishItem__editBtn"
                      disabled={isDishBeingAdded ? true : false}
                      onClick={() => {
                        handleAddDishInUpdate(menuDish.dishBody._id);
                        setIsDishBeingAdded(true);

                        setTimeout(() => {
                          window.scrollBy({ top: 100, behavior: "smooth" });
                        }, 100);
                      }}
                    >
                      <svg
                        className="bi bi-pencil"
                        width="1em"
                        height="1em"
                        viewBox="0 0 20 20"
                        fill="var(--btn-border-color-green)"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fillRule="evenodd"
                          d="M13.293 3.293a1 1 0 011.414 0l2 2a1 1 0 010 1.414l-9 9a1 1 0 01-.39.242l-3 1a1 1 0 01-1.266-1.265l1-3a1 1 0 01.242-.391l9-9zM14 4l2 2-9 9-3 1 1-3 9-9z"
                          clipRule="evenodd"
                        />
                        <path
                          fillRule="evenodd"
                          d="M14.146 8.354l-2.5-2.5.708-.708 2.5 2.5-.708.708zM5 12v.5a.5.5 0 00.5.5H6v.5a.5.5 0 00.5.5H7v.5a.5.5 0 00.5.5H8v-1.5a.5.5 0 00-.5-.5H7v-.5a.5.5 0 00-.5-.5H5z"
                          clipRule="evenodd"
                        />
                      </svg>
                    </button>
                  </div>
                  {dishesInUpdate.indexOf(menuDish.dishBody._id) ===
                  -1 ? null : (
                    <SelectDishForm
                      menu={menuInEdit}
                      dishes={dishes}
                      isDishesLoading={isDishesLoading}
                      dishProp={menuDish}
                      dishPropIndex={index}
                      dishPropRemoveId={menuDish.dishBody._id}
                      handleAddDishToMenuAndClose={handleUpdateDish}
                      handleCloseSelectDishForm={() => {
                        handleRemoveDishFromUpdate(menuDish.dishBody._id);
                        setIsDishBeingAdded(false);
                      }}
                    />
                  )}
                </React.Fragment>
              ))}
        </div>
        {isAddDishFormOpen ? (
          <SelectDishForm
            menu={menuInEdit}
            dishes={dishes}
            isDishesLoading={isDishesLoading}
            handleAddDishToMenuAndClose={handleAddDish}
            handleCloseSelectDishForm={() => {
              setIsAddDishFormOpen(false);
              setIsDishBeingAdded(false);
            }}
          />
        ) : null}
        <button
          className={`menuBodyDiv__addDishBtn
                        ${
                          isAddDishFormOpen
                            ? "menuBodyDiv__addDishBtn--hidden"
                            : ""
                        }
                    `}
          disabled={isDishBeingAdded}
          onClick={() => {
            setIsAddDishFormOpen(true);
            setIsDishBeingAdded(true);
            setTimeout(() => {
              window.scrollTo({
                top:
                  document
                    .querySelector(
                      `#menuBodyDiv__dishesDiv${
                        isFromCopy
                          ? originalMenuId.trim()
                          : (menu._id ? menu._id.trim() : "") + "id"
                      }`
                    )
                    .getBoundingClientRect().bottom +
                  window.scrollY -
                  50
              });
            }, 100);
          }}
        >
          add item
        </button>
      </div>
      <div className="menuComponent__controlsDiv">
        <button
          className="controlsDiv__saveEditMenuBtn"
          onClick={() => {
            if (
              menuInEdit.name &&
              menuInEdit.dishes.length &&
              menuInEdit.dishes.length !== 0
            ) {
              if (!isFromCopy && !isFromUpdate) {
                handleSaveMenu(menuInEdit, setMenuInEdit);
              } else if (isFromCopy) {
                handleSaveMenu(menuInEdit, originalMenuId);
              } else if (isFromUpdate) {
                handleSaveMenu(originalMenuId, menuInEdit);
              }
            } else {
              alert(
                `Fields ${!menuInEdit.name ? '"menu name"' : ""}${
                  !menuInEdit.dishes.length ? ' "items"' : ""
                } can not be empty`
              );
            }
          }}
          disabled={
            isAddDishFormOpen || dishesInUpdate.length !== 0 ? true : false
          }
        >
          SAVE
        </button>
        <button
          className="controlsDiv__cancelEditMenuBtn"
          onClick={() => {
            if (isFromCopy) {
              handleCancel(originalMenuId);
            } else {
              handleCancel(setMenuInEdit);
            }
          }}
        >
          CANCEL
        </button>
      </div>
    </div>
  );
};

export default MenuEditorGeneral;
